import axiosRequest from "@/api/axios-optimize"
export function getCacheList(
  data = {},
  config = {
    noShowLoading: true, // 配置不展示加载动画
    preventDuplicateRequestsType: "cancel" // 配置重复请求时 取消前面的请求
  }
) {
  return axiosRequest.get(`/xiaobuAdmin/monitor/cache/getCacheList`, { params: data, ...config })
}

export function getCacheKeyList(
  data = {},
  config = {
    noShowLoading: true, // 配置不展示加载动画
    preventDuplicateRequestsType: "cancel" // 配置重复请求时 取消前面的请求
  }
) {
  return axiosRequest.get(`/xiaobuAdmin/monitor/cache/getCacheKeyList`, { params: data, ...config })
}

export function getCacheInfo(
  data = {},
  config = {
    noShowLoading: true, // 配置不展示加载动画
    preventDuplicateRequestsType: "cancel" // 配置重复请求时 取消前面的请求
  }
) {
  return axiosRequest.get(`/xiaobuAdmin/monitor/cache/getCacheInfo`, { params: data, ...config })
}

export function delCacheByKey(data = {}, config = {}) {
  return axiosRequest.delete(`/xiaobuAdmin/monitor/cache/delCacheByKey`, { data, ...config })
}

export function delCacheByFolder(data = {}, config = {}) {
  return axiosRequest.delete(`/xiaobuAdmin/monitor/cache/delCacheByFolder`, { data, ...config })
}

export function flushAllRedis(data = {}, config = {}) {
  return axiosRequest.delete(`/xiaobuAdmin/monitor/cache/flushAllRedis`, { data, ...config })
}

// 获取缓存信息
export function getRedisInfo(
  data = {},
  config = {
    preventDuplicateRequestsType: "cancel" // 配置重复请求时 取消前面的请求
  }
) {
  return axiosRequest.get(`/xiaobuAdmin/monitor/cache/getRedisInfo`, { params: data, ...config })
}